var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { hk_employer_seek_com, hk_employer_staging_seek_com, id_employer_seek_com, id_employer_staging_seek_com, my_employer_seek_com, my_employer_staging_seek_com, nz_employer_staging_seek_com, ph_employer_seek_com, ph_employer_staging_seek_com, sg_employer_seek_com, sg_employer_staging_seek_com, talent_seek_co_nz, talent_seek_com_au, talent_staging_seek_co_nz, talent_staging_seek_com_au, th_employer_seek_com, th_employer_staging_seek_com, } from '../../../config/index.js';
export var stagingConfigs = [
    hk_employer_staging_seek_com,
    id_employer_staging_seek_com,
    my_employer_staging_seek_com,
    ph_employer_staging_seek_com,
    sg_employer_staging_seek_com,
    th_employer_staging_seek_com,
    nz_employer_staging_seek_com,
    talent_staging_seek_co_nz,
    talent_staging_seek_com_au,
];
export var prodConfigs = [
    hk_employer_seek_com,
    id_employer_seek_com,
    my_employer_seek_com,
    ph_employer_seek_com,
    sg_employer_seek_com,
    th_employer_seek_com,
    talent_seek_co_nz,
    talent_seek_com_au,
];
var mappings = (function () {
    var devConfigs = {
        'talent.seek.com.au.local': talent_staging_seek_com_au,
        'talent.seek.com.au.test': talent_staging_seek_com_au,
        'talent.seek.co.nz.local': talent_staging_seek_co_nz,
        'talent.seek.co.nz.test': talent_staging_seek_co_nz,
        'my.employer.seek.com.local': my_employer_staging_seek_com,
        'sg.employer.seek.com.local': sg_employer_staging_seek_com,
        'id.employer.seek.com.local': id_employer_staging_seek_com,
        'ph.employer.seek.com.local': ph_employer_staging_seek_com,
        'hk.employer.seek.com.local': hk_employer_staging_seek_com,
        'th.employer.seek.com.local': th_employer_staging_seek_com,
        'au.employer.seek.com.local': talent_staging_seek_com_au,
        'nz.employer.seek.com.local': nz_employer_staging_seek_com,
    };
    var result = __assign({}, devConfigs);
    var configs = __spreadArray(__spreadArray([], stagingConfigs, true), prodConfigs, true);
    for (var _i = 0, configs_1 = configs; _i < configs_1.length; _i++) {
        var config = configs_1[_i];
        result[config.clientDomain] = config;
    }
    return result;
})();
export default (function (_a) {
    var host = _a.host;
    var hostName = (host ? host.split(':')[0] : host);
    if (Object.keys(mappings).includes(hostName)) {
        return mappings[hostName];
    }
    var baseConfig = (hostName === null || hostName === void 0 ? void 0 : hostName.includes('.co.nz'))
        ? talent_staging_seek_co_nz
        : talent_staging_seek_com_au;
    return __assign(__assign({}, baseConfig), (host && { clientDomain: host }));
});
//# sourceMappingURL=hirer.js.map